import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {UsersManagementService as UsersManagementApiService} from '../../../api/services/users-management.service';
import {catchError, finalize} from 'rxjs/operators';
import {AccountUser} from '../../../api/models/account-user';
import {UsersGridRequest} from '../../../api/models/users-grid-request';
import {AccountUsersGridResponse} from '../../../api/models/account-users-grid-response';


export class UsersDatasource implements DataSource<AccountUser> {

  constructor(private usersManagementApiService: UsersManagementApiService) {
  }

  private dataSubject = new BehaviorSubject<AccountUser[]>([]);
  private dataTotalSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(true);

  public loading$ = this.loadingSubject.asObservable();
  public dataCount$ = this.dataTotalSubject.asObservable();

  connect(collectionViewer: CollectionViewer): Observable<AccountUser[] | ReadonlyArray<AccountUser>> {
    console.log('Connecting data source');
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    console.log('Disconnecting data source');
    this.dataSubject.complete();
    this.loadingSubject.complete();
    this.dataTotalSubject.complete();
  }

  public currentPageData(): AccountUser[] {
    return this.dataSubject.getValue();
  }

  public queryData(state: UsersGridRequest): void {
    console.log('query users');
    this.loadingSubject.next(true);

    this.usersManagementApiService
      .accountUsersGetUsers({body: state})
      .pipe(
        catchError(() => of({data: [], total: 0})),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe((response: AccountUsersGridResponse) => {
        this.dataTotalSubject.next(response.total);
        this.dataSubject.next(response.data);
      });
  }
}
